import React from "react";
import Layout from "./../components/Layout/Layout";
import PageUnderConstruction from "./../components/PageUnderConstruction";

const About = () => {
    return (
        <Layout>
            <div>
                <p>this is About us</p>
            </div>
            <PageUnderConstruction />
        </Layout>
    )
}

export default About